import { render, staticRenderFns } from "./DocumentsZipDownload.vue?vue&type=template&id=3cdc8af6&scoped=true&"
import script from "./DocumentsZipDownload.vue?vue&type=script&lang=js&"
export * from "./DocumentsZipDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc8af6",
  null
  
)

export default component.exports